import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=6354bc4c"
import script from "./ProcessItem.ts?vue&type=script&lang=ts&external"
export * from "./ProcessItem.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports